import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { environment } from '../../../environments/environment';

export interface TikTokBusinessConnection {
  id: string;
  businessAccountId: string;
  advertiserAccountId: string | null;
  advertiserAccountIds?: string[];
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpires: number | null;
  refreshTokenExpires: number | null;
  isActive: boolean;
  createdDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class TikTokBusinessService {
  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  private get headers() {
    return {
      'Content-Type': 'application/json',
    };
  }

  generateOAuthUrl(businessAccountId: string): Observable<{ redirectUrl: string }> {
    return this.http.get<{ redirectUrl: string }>(
      `${environment.shout_api.url}/tiktok-business-connect/oauth/${businessAccountId}`,
      { headers: this.headers },
    );
  }

  exchangeCode(code: string, state: string): Observable<TikTokBusinessConnection> {
    return this.http.post<TikTokBusinessConnection>(
      `${environment.shout_api.url}/tiktok-business-connect/oauth/callback`,
      { code, state },
      { headers: this.headers },
    );
  }

  getConnection(businessAccountId: string): Observable<TikTokBusinessConnection | null> {
    return this.http.get<TikTokBusinessConnection | null>(
      `${environment.shout_api.url}/tiktok-business-connect/${businessAccountId}`,
      { headers: this.headers },
    );
  }

  disconnect(businessAccountId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.shout_api.url}/tiktok-business-connect/${businessAccountId}`,
      { headers: this.headers },
    );
  }

  getAdvertiserAccounts(businessAccountId: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.shout_api.url}/tiktok-business-connect/${businessAccountId}/advertisers`,
      { headers: this.headers },
    );
  }
}
